// useEffectiveRoot — rol ROOT EFECTIVO para superficies del rollout, por feature.
//
// "Efectivo" = el FE cree que es root (useSubscription.isRoot) Y el backend NO lo ha
// desmentido en esta sesión (rechazo terminal REQUIRES_ROOT registrado en roleRejection
// por el outbox). Sin la segunda condición, un usuario con divergencia FE↔backend entra
// al loop clic→optimista→rebote→revert→clic (lección de menu-v2).
//
// Devuelve:
//   - `undefined` → el rol AÚN no se resuelve (antes de /v1/auth/account-details). Las
//     superficies NO deben montar un CTA potencialmente equivocado: no montar nada (E#4).
//   - `true` / `false` → root efectivo sí/no.
//
// Extraído del patrón duplicado en MenuVersionInvitation/MenuVersionStatusChip para que
// las features del contrato FeatureGate (coachmark BLE, controles de versión) lo reusen.

import { useCallback, useSyncExternalStore } from 'react';
import { useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { isRoleRejected, subscribeRoleRejection } from '@utils/featureRollout/roleRejection';
import { getActiveCommerceId } from '@utils/featureRollout/cache';

export function useEffectiveRoot(featureKey: string): boolean | undefined {
  const { isRoot } = useSubscription();
  const subscribe = useCallback((cb: () => void) => subscribeRoleRejection(featureKey, cb), [featureKey]);
  const getRejected = useCallback(() => isRoleRejected(getActiveCommerceId(), featureKey), [featureKey]);
  const roleRejected = useSyncExternalStore(subscribe, getRejected, getRejected);
  if (isRoot === undefined) return undefined;
  return Boolean(isRoot) && !roleRejected;
}
